import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/PricingPlans.css';

const PricingPlans = () => {
  const { t } = useTranslation();

  const handleContactClick = (e) => {
    e.preventDefault();
    const contactElement = document.getElementById('contact');
    if (contactElement) {
      const offset = 80; // Navbar height offset
      const elementPosition = contactElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const features = [
    { key: 'databaseConnections' },
    { key: 'aiBot' },
    { key: 'semanticLayer' },
    { key: 'notifications' },
    { key: 'collaboration' },
    { key: 'reports' },
    { key: 'dashboardPages' }
  ];

  return (
    <section id="pricing" className="pricing-plans">
      <div className="pricing-container">
        <h2 className="pricing-title">{t('pricing.title')}</h2>
        
        <div className="pricing-cards">
          {/* Free Tier Card */}
          <div className="pricing-card free-tier">
            <div className="card-header">
              <h3 className="plan-name">{t('pricing.freeTier')}</h3>
              <div className="plan-price">
                <span className="price-amount">{t('pricing.priceFree')}</span>
                <span className="price-period">{t('pricing.pricePeriod')}</span>
              </div>
              <p className="plan-description">{t('pricing.freeDescription')}</p>
            </div>
            
            <ul className="features-list">
              {features.map((feature, index) => (
                <li key={index} className="feature-item">
                  <span className="feature-icon">×</span>
                  <div className="feature-content">
                    <span className="feature-title">{t(`pricing.features.${feature.key}.title`)}</span>
                    <span className="feature-description">{t(`pricing.features.${feature.key}.description`)}</span>
                  </div>
                </li>
              ))}
            </ul>
            
            <button className="plan-button free-button">{t('pricing.getStarted')}</button>
          </div>

          {/* Owlex PRO Card */}
          <div className="pricing-card pro-tier">
            <div className="card-header">
              <h3 className="plan-name">{t('pricing.proTier')}</h3>
              <div className="plan-price">
                <span className="price-amount">{t('pricing.priceContact')}</span>
              </div>
              <p className="plan-description">{t('pricing.proDescription')}</p>
            </div>
            
            <ul className="features-list">
              {features.map((feature, index) => (
                <li key={index} className="feature-item">
                  <span className="feature-icon">✓</span>
                  <div className="feature-content">
                    <span className="feature-title">{t(`pricing.features.${feature.key}.title`)}</span>
                    <span className="feature-description">{t(`pricing.features.${feature.key}.description`)}</span>
                  </div>
                </li>
              ))}
            </ul>
            
            <button 
              className="plan-button pro-button"
              onClick={handleContactClick}
            >
              {t('pricing.contactUs')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingPlans;

